import { _post, _get, _delete } from "./Axios";

export default class KpiRealisasiApi {
  static get(id = null) {
    if (id == null) {
      return _get("realisasi/asignment/list");
    } else {
      return _get("realisasi/asignment/list/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("realisasi/asignment/list?" + params);
  }
  static post(data) {
    return _post("realisasi/asignment/list", data);
  }
  static update(id, data) {
    return _post("realisasi/asignment/list/" + id, data);
  }
  static delete(id) {
    return _delete("realisasi/asignment/list/" + id);
  }

  static addRealisasiKpi(data) {
    return _post("realisasi/kpi", data);
  }

  static addRealisasiKinerja(data) {
    return _post("realisasi/kinerja", data);
  }
  static updateRealisasiKinerja(data) {
    return _post("realisasi/kinerja/update", data);
  }

  static addRealisasiPenugasanKhusus(data) {
    return _post("realisasi/penugasan-khusus", data);
  }
  static deleteRealisasiPenugasanKhusus(id) {
    return _delete("realisasi/penugasan-khusus/"+ id);
  }

  static addRealisasiPengurangan(data) {
    return _post("realisasi/pengurangan", data);
  }

  static updateStatusKpi(data) {
    return _post("penilaian/revisi/status", data);
  }

  static checkRealisasiKpi(data) {
    return _post("realisasi/check", data);
  }
}
